// extracted by mini-css-extract-plugin
export default {"TravelInstructions":"TravelInstructions_TravelInstructions__g2WUr","rotation":"TravelInstructions_rotation__jqooK"};